import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getReportAttendanceHost = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/host?${queries}` });

  return data;
};

export default getReportAttendanceHost;
